// 自定义过滤器

/**
 * time to Format Filter
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function _time_to_format(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**
 * duration to time Filter
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function _duration_to_format(time) {
  if (!time) time = 0
  let min = parseInt(time/60)
  let second = parseInt(time%60)
  min = min>=10?min:"0"+min
  second = second>=10?second:"0"+second
  return min+":"+second
}



// WEBPACK FOOTER //
// ./src/utils/my_filter.js